import { BudgetCategoriesTable, BudgetSummary } from './components';
import { useBudget } from '@/context/BudgetContext';
import { useTrips } from '@/context/TripsContext';
import { useEffect } from 'react';

export const BudgetPage = (): React.ReactNode => {
  // const { tripId } = useParams();
  const { currentTrip } = useTrips();
  const { budgetCategories, refresh } = useBudget();

  useEffect(() => {
    if (!currentTrip?.id) return;
    refresh(currentTrip.id);
  },[currentTrip?.id, refresh]);

  return (
    <div className="flex flex-col gap-8">
      <BudgetSummary />
      <BudgetCategoriesTable categories={budgetCategories} />
    </div>
  );
};

